<section aria-label="Add Internal Link">

  <h2>Add Internal Link</h2>

  <form #form="ngForm">
    <div class="grid-x">
      <div class="auto cell">
        <label>
          <span class="label-text required">Display Text: (i.e. "My Organization")</span>
          <input id="text" name="text" type="text" [(ngModel)]="linkText" #title="ngModel" required>
        </label>
        @if (title.errors && (title.dirty || title.touched)) {
          <div class="error-container">
            @if (title.errors) {
              <small class="error">Text is required</small>
            }
          </div>
        }
        <label>
          <span class="label-text required">Route: (i.e. /common/organization)</span>
          <input id="route" name="route" type="text" [(ngModel)]="linkRoute" #route="ngModel" required>
        </label>
        @if (route.errors && (route.dirty || route.touched)) {
          <div class="error-container">
            @if (route.errors) {
              <small class="error">Route is required</small>
            }
          </div>
        }
        <label>
          <span class="label-text">System Permission: <help-text [helpText]="'A dashboard permission will be created if left blank.'" [position]="'right'"></help-text></span>
          <input id="permission" name="permission" type="text" [(ngModel)]="permission" />
        </label>
      </div>
    </div>
    <hr />
    <div class="form-button-group">
      <button class="button hollow margin-right" (click)="cancel()">Cancel</button>
      <button class="button" (click)="save()" [disabled]="route.invalid || title.invalid">Save</button>
    </div>
  </form>
</section>